import Izzihome1 from '../../Media/homeimages/Izzi.png'
import Izzihome2 from '../../Media/homeimages/Izzi.png'





const Izzihomeimages =[
Izzihome1,Izzihome2
]

export default Izzihomeimages;